import { Lead } from '@/services/leads'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { format } from 'date-fns'
import { pt } from 'date-fns/locale'
import { Badge } from '@/components/ui/badge'

interface LeadDetailsDialogProps {
  lead: Lead | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function LeadDetailsDialog({
  lead,
  open,
  onOpenChange,
}: LeadDetailsDialogProps) {
  if (!lead) return null

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'new':
        return 'Novo'
      case 'contacted':
        return 'Em Contacto'
      case 'closed':
        return 'Fechado'
      default:
        return status
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Detalhes do Lead</DialogTitle>
          <DialogDescription>
            Informação completa submetida a{' '}
            {format(
              new Date(lead.created_at),
              "d 'de' MMMM 'de' yyyy 'às' HH:mm",
              { locale: pt },
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="grid gap-6 py-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-1">
              <h4 className="text-sm font-medium text-muted-foreground">
                Nome Completo
              </h4>
              <p className="text-base font-medium text-foreground">
                {lead.full_name}
              </p>
            </div>
            <div className="space-y-1">
              <h4 className="text-sm font-medium text-muted-foreground">
                Status
              </h4>
              <Badge variant="outline" className="capitalize">
                {getStatusLabel(lead.status)}
              </Badge>
            </div>
            <div className="space-y-1">
              <h4 className="text-sm font-medium text-muted-foreground">
                Email
              </h4>
              <p className="text-base text-foreground break-all">
                {lead.email}
              </p>
            </div>
            <div className="space-y-1">
              <h4 className="text-sm font-medium text-muted-foreground">
                Área de Negócio
              </h4>
              <p className="text-base text-foreground">
                {lead.business_area || 'Não especificado'}
              </p>
            </div>
          </div>

          <div className="space-y-2">
            <h4 className="text-sm font-medium text-muted-foreground">
              Mensagem
            </h4>
            <div className="rounded-md bg-muted p-4 text-sm leading-relaxed whitespace-pre-wrap max-h-[300px] overflow-y-auto">
              {lead.message || 'Sem mensagem.'}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
